import React, { useState } from 'react';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import CopyIcon from '@liquidweb-dev/undercurrent/icons/animated/Copy';
import useAccountDetails from 'modules/queries/account/useDetails';
import useDelayReset from 'utility/hooks/useDelayReset';
import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';

export function SmallNavAccount() {
	const [copied, setCopied] = useState(false);

	const { data: accountUserDetailsData } = useAccountDetails({});

	const accountNumber = accountUserDetailsData?.accnt;

	const handleCopy = () => {
		navigator.clipboard.writeText(accountNumber);
		setCopied(true);
	};

	// Remove check mark after 2s
	useDelayReset(copied, () => setCopied(false), 2000);

	return (
		<Stack
			direction="row"
			sx={{
				paddingY: 0,
				paddingX: 300,
				justifyContent: 'space-between',
				alignItems: 'center',
			}}
		>
			<Typography
				variant="label-lg"
				sx={{
					flex: '0% 1 1',
				}}
			>
				Account ID {accountNumber}
			</Typography>
			<Tooltip open={copied} title="Copied" placement="left">
				<IconButton variant="secondary" onClick={handleCopy}>
					<CopyIcon done={copied} />
				</IconButton>
			</Tooltip>
		</Stack>
	);
}

export default SmallNavAccount;
